export default {
    namespaced:true,
    state: {
      token:sessionStorage.getItem('token'),
      nickname:sessionStorage.getItem('nickname'),//用户昵称
      authList:JSON.parse(sessionStorage.getItem('authList')) || [], //权限列表
      realauthPath:sessionStorage.getItem('realauthPath'), //角色实际可访问页面的path集合
      defaultPatch:sessionStorage.getItem('defaultPatch'),// menu默认菜单激活
      tabs:JSON.parse(sessionStorage.getItem('tabsList')) || [],  // tabs标签页
      btnAuth:sessionStorage.getItem('btnAuth')
    },
    getters: {
    },
    mutations: {
      changetoken(state,value){
        state.token = value;
        sessionStorage.setItem('token',value)
      },
      changenickname(state,value){
        state.nickname = value;
        sessionStorage.setItem('nickname',value)
      },
        changestate(state,value){
            state.authList = value;
            sessionStorage.setItem('authList',JSON.stringify(value))
        },
        changerealauth(state,value){
            state.realauthPath = value;
            sessionStorage.setItem('realauthPath',value)
        },
        changedefaultPatch(state,value){
          state.defaultPatch = value;
          sessionStorage.setItem('defaultPatch',value)
      },
      changebtnAuth(state,value){
        state.btnAuth = value;
        sessionStorage.setItem('btnAuth',value)
    }
    },
    actions: {
    },
    modules: {
    },
  }